import React from "react";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const addAttendance = async (input) => {
  console.log(input);
  const { data } = await http_payroll.post(Api_EndPoints.AddAttendance, input);
  return data;
};

export const useAddAttendanceMutation = () => {
  return useMutation({
    mutationFn: addAttendance,
  });
};

const createMonthlyAttendance = async (input) => {
  console.log(input);
  const { data } = await http_payroll.post(
    Api_EndPoints.CreateMonthlyAttendance,
    input
  );
  return data;
};

export const useCreateMonthlyAttendanceMutation = () => {
  return useMutation({
    mutationFn: createMonthlyAttendance,
  });
};
